import { UserType } from "@/common/types"
import AutoComplete from "@/components/autocomplete"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import useDebounce from "@/hooks/use-debounce"
import { assignTestKitToDoctor } from "@/redux/actions/testKitActions"
import { getAllDoctors } from "@/redux/actions/usersActions"
import { RootState } from "@/redux/reducers"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"

const AssignToDoctor = () => {

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [formState, setFormState] = useState({
        doctor: null,
    })
    const [error, setError] = useState<string>("")

    const [searchTerm, setSearchTerm] = useState<string>("")
    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const { doctors } = useSelector((state: RootState) => state.users);

    const params = useParams()
    const dispatch: any = useDispatch()

    const handleSelect = (key: string, value: string) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value,
        }))
    }

    const validateInput = () => {
        let errorMessage = ""
        if (!formState.doctor || formState.doctor === "") {
            errorMessage = 'Doctor is required'
        } else {
            errorMessage = ''
        }
        setError(errorMessage)
        return errorMessage
    }

    const handleSubmit = () => {
        const errorMessage = validateInput()
        if (!errorMessage) {
            const payload = {
                "kit_ids": [params.id || ''],
                "doctor": formState.doctor,
            }
            dispatch(assignTestKitToDoctor(payload, () => setIsOpen(false)))
        }
    }

    useEffect(() => {
        if (isOpen)
            dispatch(getAllDoctors(debouncedSearchTerm))
    }, [isOpen, debouncedSearchTerm])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="secondary">Assign to Doctor</Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Assign to Doctor</DialogTitle>
                    <DialogDescription>
                        Add a new test kit to your dashboard.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid grid-cols-4 items-center gap-4">
                    <div className="col-span-4">
                        <AutoComplete
                            placeHolder="doctor"
                            options={doctors as UserType[]}
                            labelKey="name"
                            onSelect={(option) => handleSelect("doctor", option?.id)}
                            onChange={(search) => setSearchTerm(search)}
                            listCount={5}
                        />
                    </div>
                </div>
                {error && <div className="grid grid-cols-4 items-center gap-4">
                    <div className="col-span-4">
                        <p className="text-red-500 text-sm">{error}</p>
                    </div>
                </div>}
                <DialogFooter>
                    <Button type="submit" onClick={() => handleSubmit()}>Assign</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default AssignToDoctor
